import { useState } from "react";
import { Answer } from "@/pages/assess/AssessExtra";

export function CandidatePreview({ item, secType }) {
  const [val, setVal] = useState(item.kind === "multi" ? [] : "");
  return (
    <section className="space-y-2 rounded-[6px] border border-dashed border-line bg-surface-2/60 p-4" aria-label="Candidate sees" data-testid="drawer-preview">
      <p className="text-xs font-medium uppercase tracking-wide text-ink-muted">Candidate sees</p>
      <div className="space-y-3 rounded-[6px] bg-white p-4">
        {secType === "scenarios" ? (
          <>
            <p className="text-sm">{item.scenario || <span className="text-ink-muted">(Situation)</span>}</p>
            <ul className="space-y-1.5">{item.options.map((o) => <li key={o.id} className="rounded-lg border border-line px-3 py-2 text-sm">{o.text || "…"}</li>)}</ul>
          </>
        ) : (
          <>
            <p className="font-medium">{item.prompt || <span className="text-ink-muted">(Question)</span>}{item.required && <span className="text-risk"> *</span>}</p>
            <Answer q={item} value={val} onChange={setVal} />
          </>
        )}
      </div>
    </section>
  );
}
